// src/redux/actions/role-management/permission/permissionActions.js
import axios from "axios";
import toast from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const CREATE_PERMISSION_REQUEST = "CREATE_PERMISSION_REQUEST";
export const CREATE_PERMISSION_SUCCESS = "CREATE_PERMISSION_SUCCESS";
export const CREATE_PERMISSION_FAILURE = "CREATE_PERMISSION_FAILURE";

export const FETCH_PERMISSIONS_REQUEST = "FETCH_PERMISSIONS_REQUEST";
export const FETCH_PERMISSIONS_SUCCESS = "FETCH_PERMISSIONS_SUCCESS";
export const FETCH_PERMISSIONS_FAILURE = "FETCH_PERMISSIONS_FAILURE";

export const createPermission = (data) => async (dispatch) => {
  dispatch({ type: CREATE_PERMISSION_REQUEST });
  const token = localStorage.getItem("token");

  try {
    const response = await axios.post(
      `${BASE_URL}/v1/api/create-permission`,
      data,
      {
        headers: { authorization: token },
      },
    );

    if (response.data.meta.status) {
      dispatch({ type: CREATE_PERMISSION_SUCCESS });
      toast.success(
        response.data.meta.message || "Permission created successfully",
      );
      return response.data;
    } else {
      dispatch({ type: CREATE_PERMISSION_FAILURE });
      throw new Error(response.data.meta.message);
    }
  } catch (error) {
    dispatch({ type: CREATE_PERMISSION_FAILURE });
    toast.error(
      error.response?.data?.meta?.message || "Failed to create permission",
    );
    throw error;
  }
};

export const fetchPermissions = () => async (dispatch) => {
  dispatch({ type: FETCH_PERMISSIONS_REQUEST });
  const token = localStorage.getItem("token");

  try {
    const response = await axios.get(`${BASE_URL}/v1/api/get-permission-list`, {
      headers: { authorization: token },
    });

    if (response.data.meta.status) {
      dispatch({
        type: FETCH_PERMISSIONS_SUCCESS,
        payload: response.data.data,
      });
      return response.data;
    } else {
      dispatch({ type: FETCH_PERMISSIONS_FAILURE });
      throw new Error(response.data.meta.message);
    }
  } catch (error) {
    dispatch({ type: FETCH_PERMISSIONS_FAILURE });
    toast.error(
      error.response?.data?.meta?.message || "Failed to fetch permissions",
    );
    throw error;
  }
};
